<template>
  <div
    class="user-profile-sidebar"
    :class="{ show: shallShowActiveChatContactSidebar }"
  >
    <!-- Header -->
    <header v-if="contact" class="user-profile-header">
      <span class="close-icon">
        <feather-icon
          icon="XIcon"
          @click="$emit('update:shall-show-active-chat-contact-sidebar', false)"
        />
      </span>

      <div class="header-profile-sidebar">
        <div class="avatar box-shadow-1 avatar-xl avatar-border">
          <b-avatar size="70" :src="contact.avatar" />
          <span
            class="avatar-status-xl"
            :class="`avatar-status-${contact.isOnline ? 'online' : 'offline'}`"
          />
        </div>
        <h4 class="chat-user-name">
          {{ contact.name }}
        </h4>
      </div>
    </header>

    <!-- User Details -->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="user-profile-sidebar-area scroll-area"
    >
      <!-- Personal Info -->
      <div class="personal-info">
        <h6 class="section-label mb-1">{{ $t("chat.information") }}</h6>
        <ul class="list-unstyled">
          <li class="mb-1">
            <span class="align-middle">
              {{ $t("chat.status") }}:
              {{ contact.isOnline ? $t("chat.online") : $t("chat.offline") }}
            </span>
          </li>
          <li class="mb-1" v-if="contact.customer">
            <span class="align-middle"
              >{{ $t("chat.device") }}: {{ contact.customer.device }}</span
            >
          </li>
          <li class="mb-1" v-if="contact.customer">
            <span class="align-middle">
              {{ $t("chat.ipAddress") }}: {{ contact.customer.ipAddress }}
            </span>
          </li>
        </ul>
      </div>
      <div class="personal-info mt-4" v-if="contact.rateData">
        <h6 class="section-label mb-1">{{ $t("chat.rating") }}</h6>
        <ul class="list-unstyled">
          <li class="mb-1">
            <feather-icon
              icon="StarIcon"
              size="22"
              class="rating-star mr-1"
              :class="{
                active: i <= contact.rateData.rate,
              }"
              v-for="i in 5"
              :key="`star-${i}`"
            />
          </li>
          <li class="mb-1" v-if="contact.customer">
            {{ contact.rateData.comment }}
          </li>
        </ul>
      </div>
    </vue-perfect-scrollbar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { BAvatar } from "bootstrap-vue";

export default {
  components: {
    // BSV
    BAvatar,

    // 3rd Party
    VuePerfectScrollbar,
  },
  props: {
    shallShowActiveChatContactSidebar: {
      type: Boolean,
      required: true,
    },
    contact: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    };

    return {
      perfectScrollbarSettings,
    };
  },
};
</script>

<style></style>
